import { avatarGradients } from '../theme/theme';

/** ₹ with Indian digit grouping — matches prototype BQ.money. */
export function money(n: number): string {
  return '₹' + Number(n || 0).toLocaleString('en-IN');
}

/** Thousands-grouped integer. */
export function num(n: number): string {
  return Number(n || 0).toLocaleString('en-IN');
}

/** Two-letter initials from a name. */
export function initials(name: string): string {
  return (name || '?')
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

/** Deterministic avatar gradient (by name length) — matches prototype BQ.avatar. */
export function avatarGradient(name: string): string {
  return avatarGradients[(name || '').length % avatarGradients.length];
}

/** Title-case a status string ("in_progress" -> "In Progress"). */
export function statusLabel(status: string): string {
  return String(status)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Capacity utilization percentage. */
export function utilPct(booked: number, capacity: number): number {
  return Math.round((booked / capacity) * 100) || 0;
}

/** Capacity bar colour: blue < 50%, orange 50–80%, red > 80%. */
export function barColor(pct: number): string {
  return pct > 80 ? '#EF4444' : pct >= 50 ? '#F59E0B' : '#076FF7';
}

// ---- CSV / Excel export ----
export interface CsvColumn<T> {
  label: string;
  /** Value accessor for CSV (falls back to row[key] in the table component). */
  value: (row: T) => string | number | null | undefined;
}

function escapeCsv(v: unknown): string {
  const s = v == null ? '' : String(v);
  return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
}

export function toCSV<T>(columns: CsvColumn<T>[], rows: T[]): string {
  const head = columns.map((c) => escapeCsv(c.label)).join(',');
  const body = rows.map((r) => columns.map((c) => escapeCsv(c.value(r))).join(',')).join('\n');
  return head + '\n' + body;
}

/** Download rows as a UTF-8 (BOM) CSV that opens cleanly in Excel. */
export function downloadCSV<T>(name: string, columns: CsvColumn<T>[], rows: T[]): void {
  const blob = new Blob(['﻿' + toCSV(columns, rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = (name || 'export') + '.csv';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
